import React, { Component } from "react";
import mixinFun from "./mixins";

export class OnboardingPage extends Component {
    constructor(props) {
        super(props);
        props.initialconstruct.bind(this)("OnboardingPage");
        let mixins = mixinFun(this);
        this.state = {
            links: mixins.links || [],
            rowcount: 0,
            tableData: [],
            columns: mixins.columns,
            fields: mixins.fields([], ["user_id", "createdAt"]),
        };
    }

    fetchData(data = {}) {
        this.api.execApi("getPartnerAll").then((response) => {
            let result = response.data.items[0];
            this.setState({
                rowcount: result.total,
                tableData: result.data
            });
        });
    }

    onSearch() {
        let data = this.refs.form.form.current.getData();
        return this.fetchData(data.user_name ? {
            search_key: "user_name",
            search_value: data.user_name
        } : {});
    }

    getDocumentsAll() {

    }

    uploadDocument(e, key) {
        let input = e.target;
        let [file] = input.files;
        console.log({ e, key });
        this.api.execApi("postPartnerDocument", {
            file,
            doc_meta_name: JSON.stringify({ name: key, group: "onboarding" }).encode()
        }, {}, {
            multipart: true,
            message: "Uploading please wait...",
            onexec: () => {
                success("Upload Successfull").promise.then(() => {
                    this.getDocumentsAll();
                });
            }
        });
    }

    componentDidMount() {
        this.fetchData();
    }

    breadCumRight() {
        return <div className="col-auto float-end ml-auto">
            <a href="#" className="btn add-btn" data-bs-toggle="modal" data-bs-target="#appModal">
                <i className="fa fa-plus"></i> Onboard
            </a>
        </div>
    }

    addRecord() {
        let fileObj = ()=>{
            return {
                "attachment_id": "",
                "filename": "",
                "password": "",
                "status": ""
            }
        };
        let payload = {
            "partner_type": "Vendor OR Dealer",
            "company_type": "LLP",
            "company_name": "XYZ LLP",
            "email_address": "abc@xyz.in",
            "contact_number": "9876543210",
            "alt_contact_number": "8877665544",
            "aadhar_number": "123412341234",
            "company_pan_number": "ABCDE1234E",
            "gstin_id": "0000",
            "bank_name": "Axis Bank",
            "account_num": "10000567123",
            "ifsc": "AXIS0000001",
            "branch_name": "gachibowli",
            "account_type": "savings",
            "verification_status": "verified",
            "company_pancard": fileObj("company_pancard"),
            "company_cheque": fileObj("company_cheque"),
            "authorisation_letter": fileObj("authorisation_letter")
        };
        this.api.execApi("postPartnerByFirm",payload,{
            firm_type:payload.company_type
        }).then((response)=>{
            this.onSearch();
        });
    }

    render() {
        let { breadCumRight } = this;
        let { tableData, columns, rowcount, links, fields } = this.state;
        return (
            <AppWrapper title="Onboarding" slots={{ breadCumRight }}>
                <AppForm className="row filter-row" ref="form">
                    {columns
                        .filter((o) => o.hasFilter)
                        .map((o, i) => (
                            <div className="col" key={o.name + "" + i}>
                                <AppInputFocus
                                    type={o.type || "text"}
                                    name={o.dataIndex}
                                    label={o.title}
                                    {...Object.only(o, ["className", "options"])}
                                    className={o.className || ""}></AppInputFocus>
                            </div>
                        ))}
                    <div className="col">
                        <button className="btn btn-warning btn-block w-100" onClick={() => this.onSearch()}>
                            Search
                        </button>
                    </div>
                </AppForm>
                <div className="row mb-4">
                    <div className="col">
                        <AppTable
                            data={tableData}
                            columns={columns.filter(o => !o.notintable)}
                            reorder={true}
                            onChange={(...arg) => this.onPageChange(...arg)}
                            total={rowcount}
                            editAction={(data) => this.editAction(data)}
                            deleteAction={(data) => this.deleteAction(data)}
                            pageSize={10}></AppTable>
                    </div>
                </div>
                <AppModalForm
                    ref="addedit"
                    title="Onboard"
                    fields={fields}
                    size={3}
                    fieldclass="col-4"
                    contentClass="w-full"
                    dialogClass="modal-xl"
                    onSubmit={(...arg) => this.addRecord(...arg)}
                    submitText="Add">
                </AppModalForm>
            </AppWrapper>
        );
    }
}

export default connect(OnboardingPage);
